import { reactive } from "sitekit-extensions";
import on from "../util/elements/on";
import destroys from "../util/elements/destroys";
import anime from "animejs";

export default function(Site, $) {
  Site.widget("accordian", {
    use: [reactive()],
    _create() {
      destroys(this);
      this.header = this.element.find(".accordion-click")
        ? this.element.find(".accordion-click")
        : this.element.find(".accordian-header");
      this.content = this.element.find(".accordian-content");
      this.indicator = this.element.find(".accordian-indicator");

      this.state = { open: false, height: this.getHeight() };
      this.wasClicked = false;

      const onClick = on(this.header, "click", (e) => {
        e.preventDefault();
        this.setState({ open: !this.state.open });
      });

      const onResize = on(window, "resize", (e) => {
        this.setState({ height: this.getHeight() });
      });

      const onGeneralClick = on(this.element, "click", (e) => {
        this.wasClicked = true;
      });

      const onWindowClick = on(window, "click", (e) => {
        if (this.wasClicked) {
          this.wasClicked = false;
          return;
        }

        this.setState({ open: false });
      });

      this.destroys(onResize, onClick, onWindowClick, onGeneralClick);
    },
    getHeight() {
      this.content.css({ height: "" });
      const height = this.content.height();

      if (this.state && !this.state.open) this.content.css({ height: 0 });

      return height;
    },
    react() {
      this.setState({ height: this.getHeight() });
      this.changed("height", () => {
        if (this.state.open) {
          this.content.height(this.state.height);
        }
      });

      this.changed("open", () => {
        const open = this.state.open;

        const el = this.content.get(0);

        anime.remove(el);
        anime({
          targets: el,
          height: open ? this.state.height : 0,
          easing: "easeOutQuad",
          duration: 400,
        });

        this.element.toggleClass("open", open);
        this.indicator.toggleClass("open", open);
      });
    },
  });
}
